export default __webpack_public_path__ + "resources/icons/n422-990b.webp";